import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppMenuService } from 'app/business/service/app/app-menu.service';
import { AppUserService } from 'app/business/service/app/app-user.service';
import { DxDataGridComponent } from 'devextreme-angular';
import * as moment from 'moment';
import { UserRoleModalComponent } from '../user-role-modal/user-role-modal.component';
import { UserGroupModalComponent } from '../user-group-modal/user-group-modal.component';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
  selector: 'app-user-group-list',
  templateUrl: './user-group-list.component.html',
  styleUrls: ['./user-group-list.component.css']
})
export class UserGroupListComponent implements OnInit {

  userGroupListDataSource: any[];
  lookupStatusCode: any[];
  @Input() filter: any;
  url;
  buttonList: any;
  userToken:any;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  constructor(
    private dialog: MatDialog,
    private appUserService: AppUserService,
    private appMenuService: AppMenuService,
    private router: Router,
    private _authService: AuthService,
    
  ) {
    this.userGroupListDataSource = new Array();
   }

   async ngOnInit() {
    this.userToken = JSON.parse(
      this._authService.loginUser
    );

    await this.getRouter();
    this.setSubcribe();

  }

  getUserRoleList(): void {
    this.appUserService.getUserGroupList(this.filter);
  }

  async getRouter(): Promise<void>{
    this.url = this.router.url;

    const formData = {
      url: this.url,
      userGroupCode: this.userToken.userGroupCode,
      userRoleCode: this.userToken.userRoleCode,
      userCode: this.userToken.userCode
    };
    this.buttonList = await this.appMenuService.getButtonPermissionPerPages(formData);
  }
  setSubcribe(): void {
    this.lookupStatusCode = [
      { code: "Y", name: "ใช้งาน" },
      { code: "N", name: "ยกเลิก" },
    ];

    this.appUserService.userGroupList.subscribe(res => {
      if (res && res.length > 0) {
        this.userGroupListDataSource = res;

        this.userGroupListDataSource.forEach((item, i) => {
          item.createDate = item.createDate ? moment(item.createDate).format('DD/MM/YYYY') : '';
          item.updateDate = item.updateDate ? moment(item.updateDate).format('DD/MM/YYYY') : '';
        });
      } else {
        this.userGroupListDataSource = new Array();
      }
    });
  }

  editUserGroup(row: any): void {
    
    const userModalRef = this.dialog.open(UserGroupModalComponent, {
      disableClose: true,
      width: '60vw',
      data: row
    });

    userModalRef.afterClosed().subscribe(res => {
      this.getUserRoleList();
    });
  }
  checkButton(buttonCode: string) {
    var checkBtn = this.buttonList.find(e => e.buttonCode == buttonCode);

    if (checkBtn != undefined) {
      return true;
    } else {
      return false;
    }
  }
}
